export default __webpack_public_path__ + "static/media/Saibaba11.b1f419f8.jpg";